import { render, staticRenderFns } from "./UnsuccessDeliveryCost.vue?vue&type=template&id=497f3337&lang=pug&"
import script from "./UnsuccessDeliveryCost.vue?vue&type=script&lang=ts&"
export * from "./UnsuccessDeliveryCost.vue?vue&type=script&lang=ts&"
import style0 from "./UnsuccessDeliveryCost.vue?vue&type=style&index=0&id=497f3337&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports